import { render, staticRenderFns } from "./gift-card-purchase.vue?vue&type=template&id=39dce9d8"
import script from "./gift-card-purchase.vue?vue&type=script&lang=js"
export * from "./gift-card-purchase.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {GiftCardInput: require('/home/ubuntu/complete-nuxt-js/components/gift-card-input.vue').default})
